import { Link } from 'react-router-dom';
import { comparisonData } from '@/mocks/seo';

export default function ComparisonTable() {
  return (
    <section className="w-full py-16 md:py-24 bg-background-50">
      <div className="max-w-6xl mx-auto px-6 md:px-8 lg:px-12">
        <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-950 text-center">
          Top Mulebuy Spreadsheet Systems
        </h2>
        <p className="mt-3 text-sm text-foreground-500 font-sans text-center">
          2026 Updated Ranking
        </p>

        <div className="mt-10 overflow-x-auto rounded-2xl border border-background-200">
          <table className="w-full text-left">
            <thead>
              <tr className="bg-background-100 border-b border-background-200">
                <th className="px-5 py-4 text-xs font-semibold text-foreground-500 font-sans uppercase tracking-wider">Rank</th>
                <th className="px-5 py-4 text-xs font-semibold text-foreground-500 font-sans uppercase tracking-wider">Mulebuy Spreadsheet</th>
                <th className="px-5 py-4 text-xs font-semibold text-foreground-500 font-sans uppercase tracking-wider">Speed</th>
                <th className="px-5 py-4 text-xs font-semibold text-foreground-500 font-sans uppercase tracking-wider">Accuracy</th>
                <th className="px-5 py-4 text-xs font-semibold text-foreground-500 font-sans uppercase tracking-wider">Usability</th>
                <th className="px-5 py-4 text-xs font-semibold text-foreground-500 font-sans uppercase tracking-wider">Score</th>
              </tr>
            </thead>
            <tbody>
              {comparisonData.map((row) => (
                <tr key={row.rank} className="border-b border-background-200 last:border-b-0 hover:bg-background-50 transition-colors">
                  <td className="px-5 py-4">
                    <span className={`inline-flex items-center justify-center w-7 h-7 rounded-full text-xs font-bold ${
                      row.rank === 1 ? 'bg-accent-500 text-white' : 'bg-background-200 text-foreground-600'
                    }`}>
                      #{row.rank}
                    </span>
                  </td>
                  <td className="px-5 py-4 font-sans text-sm font-semibold text-foreground-950">{row.name}</td>
                  <td className="px-5 py-4 font-sans text-sm text-foreground-700">{row.speed}</td>
                  <td className="px-5 py-4 font-sans text-sm text-foreground-700">{row.accuracy}</td>
                  <td className="px-5 py-4 font-sans text-sm text-foreground-700">{row.usability}</td>
                  <td className="px-5 py-4 font-sans text-sm font-bold text-accent-600">{row.score}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <div className="mt-6 text-center">
          <Link
            to="/mulebuy-spreadsheet-comparison-2026"
            className="inline-flex items-center gap-2 px-6 py-3 text-sm font-semibold bg-accent-500 text-white rounded-full hover:bg-accent-600 transition-all whitespace-nowrap cursor-pointer"
          >
            View Full Mulebuy Spreadsheet Comparison
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}